export default "__VITE_ASSET__CZ19LKF3__"